import { render } from "./LoginModalComponent.vue?vue&type=template&id=a97d4ae6&scoped=true"
import script from "./LoginModalComponent.vue?vue&type=script&lang=js"
export * from "./LoginModalComponent.vue?vue&type=script&lang=js"

import "./LoginModalComponent.vue?vue&type=style&index=0&id=a97d4ae6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97d4ae6"]])

export default __exports__